import { useCallback } from "react";
import useTrack from "../../game/hooks/use-track";
import { useUserModuleDispatch, USER_MODULE_ACTION } from "..";
import useUserAnswers from "./use-user-answers";
import useShowPopup from "../../result-popup/hooks/use-show-popup";
import { RESPONSE_LIMIT } from "../../game";

export default function useUserChooseAnswer(trackId: TrackId) {
    const {track} = useTrack(trackId);
    const dispatch = useUserModuleDispatch();
    const answers = useUserAnswers(trackId);
    const showPopup = useShowPopup();

    return useCallback((schoolId: SchoolId) => {
        const isCorrect = schoolId === track?.correct;

        //DEV: showPopup musi być przed dispatch
        showPopup(isCorrect, RESPONSE_LIMIT - answers.length - 1);

        dispatch({
            type: USER_MODULE_ACTION.CHOOSE_ANSWER,
            payload: {
                trackId,
                answer: schoolId,
                isCorrect
            }
        })

    }, [trackId, track, dispatch, answers.length, showPopup])
}
